import React, { useState } from 'react';
import { View, Modal } from 'react-native';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import Toast from 'react-native-toast-message';
import { WindowInformation } from '../../../services/window-information';
import { translate } from '../../../services/translate';
import MyAppText from '../../../components/MyAppText';
import FormActions from '../../../components/FormActions';
import InChargeArmourerDropdown from '../../../components/armory/InChargeArmourerDropdown';
import { armoryService } from '../../../services/central-api/armory';


interface ModalProps {
    isModalVisible: boolean;
    setModalVisible: (value: boolean) => void;
    onSubmit: () => void;
    armoryShiftId: number;
}

export default function ReplaceInChargeModal({
    isModalVisible,
    setModalVisible,
    armoryShiftId,
    onSubmit
}: ModalProps) {
    const { styles } = useStyles(styleSheet);

    const windowInfo = WindowInformation();
    const [newInChargeArmourerId, setNewInChargerArmourerId] = useState<number>(0);

    async function onConfirm() {
        try {
            await armoryService.replaceInChargeArmourer({
                armoryShiftId,
                newInChargeArmourerId
            });
            onSubmit();
            onClose();
            Toast.show({
                type: 'sentinelxSuccess',
                text1: translate('ActionSuccessfully'),
            });
        } catch (err) {
            console.error(err);
            Toast.show({
                type: 'sentinelxError',
                text1: translate('unexpectedError'),
            });
        }
    }

    function onClose() {
        setNewInChargerArmourerId(0);
        setModalVisible(false);
    }

    return (
        <Modal
            visible={isModalVisible}
            animationType='fade'
            onRequestClose={onClose}
            transparent={true}
        >
            <View style={styles.container}>
                <View style={styles.body(windowInfo.isMobile)}>
                    <View style={{ gap: 16, justifyContent: 'center', alignItems: 'center' }}>
                        <MyAppText style={styles.headerText}>{translate('replaceInCharge')}</MyAppText>
                        <MyAppText style={styles.contentText}>{translate('replaceInChargeText')}</MyAppText>
                    </View>

                    <InChargeArmourerDropdown
                        value={newInChargeArmourerId}
                        setValue={setNewInChargerArmourerId}
                        zIndex={3}
                        required={true}
                        labelFontSize={14}
                        disabled={false}
                        armoryShiftId={armoryShiftId}
                    />
                    <FormActions
                        confirmText='confirm'
                        onSubmit={() => onConfirm()}
                        onClose={onClose}
                        disabled={newInChargeArmourerId === 0}
                    />
                </View>
            </View>
        </Modal>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    container: {
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#31313199',
        flex: 1
    },
    body: (isMobile: boolean) => {
        return {
            backgroundColor: theme.colors.white['500'],
            flexDirection: 'column',
            borderRadius: 8,
            padding: 32,
            rowGap: 25,
            maxWidth: isMobile ? '95%' : 400
        };
    },
    headerText: {
        fontSize: 18,
        color: theme.colors.neutral['500'],
        fontWeight: '600'
    },
    contentText: {
        fontSize: 16,
        color: theme.colors.neutral['400'],
    }
}));
